import { createContext } from 'react';
import { AxiosInstance } from 'axios';
import { DrinkUpServiceApiContextType } from './types';

export const DrinkUpServiceApiContext = createContext<DrinkUpServiceApiContextType>({
    drinkUpService: null as unknown as AxiosInstance
});